const state = {
  test: ''
}

const getters = {
  test (state) {
    return state.test
  }
}

const actions = {
  setTest ({commit}, test) {
    commit('SET_TEST', test)
  },
  setQuestion ({commit}, question) {
    commit('SET_QUESTION', question)
  },
  addQuestion ({commit}, question) {
    commit('ADD_QUESTION', question)
  },
  deleteQuestion ({commit}, questionId) {
    commit('DELETE_QUESTION', questionId)
  },
  setAnswer ({commit}, payload) { // questionId, answer
    commit('SET_ANSWER', payload)
  },
  addAnswerToQuestion ({commit}, payload) { // questionId, answer
    commit('ADD_ANSWER', payload)
  },
  deleteAnswerFromQuestion ({commit}, payload) { // questionId, answerId
    commit('DELETE_ANSWER', payload)
  },
  setTestPoint ({commit}, payload) { // key, value
    commit('SET_TEST_POINT', payload)
  },
  deletePoint ({commit}, point) { // key, value
    commit('DELETE_POINT', point)
  }
}

const mutations = {
  SET_TEST (state, test) {
    state.test = test
  },
  SET_TEST_POINT (state, payload) {
    if (Object.keys(state.test.points).length === 0) {
      state.test.points = []
    }
    const pointIndex = state.test.points.findIndex(
      x => x.name === payload.name)
    if (pointIndex === -1) {
      state.test.points.push(payload)
    } else {
      state.test.test_points[pointIndex] = payload
    }
  },
  DELETE_POINT (state, point) {
    const pointIndex = state.test.points.findIndex(
      x => x.name === point.name)
    state.test.points.splice(pointIndex, 1)
  },
  SET_QUESTION (state, question) {
    const index = state.test.test_questions.findIndex(
      x => x.id === parseInt(question.id))
    state.test.test_questions[index] = question
  },
  ADD_QUESTION (state, question) {
    state.test.test_questions.push(question)
  },
  DELETE_QUESTION (state, questionId) {
    const questionIndex = state.test.test_questions.findIndex(
      x => x.id === parseInt(questionId))
    state.test.test_questions.splice(questionIndex, 1)
  },
  SET_ANSWER (state, payload) {
    const questionIndex = state.test.test_questions.findIndex(
      x => x.id === parseInt(payload.questionId))
    let question = state.test.test_questions[questionIndex]
    const answerIndex = question.question_answers.findIndex(
      x => x.id === parseInt(payload.answer.id))
    question.question_answers[answerIndex] = payload.answer
  },
  ADD_ANSWER (state, payload) {
    const questionIndex = state.test.test_questions.findIndex(
      x => x.id === parseInt(payload.questionId))
    let question = state.test.test_questions[questionIndex]
    question.question_answers.push(payload.answer)
  },
  DELETE_ANSWER (state, payload) {
    const question = state.test.test_questions.find(
      x => x.id === parseInt(payload.questionId))
    const answerIndex = question.question_answers.findIndex(
      x => x.id === parseInt(payload.answerId))
    question.question_answers.splice(answerIndex, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/test.js